const buildLinkedData = (url, breadcrumb) => {
  if (breadcrumb && breadcrumb.length > 0) {
    return {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: breadcrumb.map((elem, key, all) => {
        const breadcrumdJson = {
          '@type': 'ListItem',
          position: key,
          name: elem.name,
        };
        if (key + 1 < all.length) breadcrumdJson.item = getItemValue(url, elem.url);
        return breadcrumdJson;
      })
    };
  }
  return '';
};

const getItemValue = (url, elemUrl) => {
  const urlWithEndSlash = getUrlWithEndSlash(url);
  if (url === elemUrl || urlWithEndSlash === elemUrl) {
    return urlWithEndSlash;
  } else {
    return urlWithEndSlash + elemUrl;
  }
};

const getUrlWithEndSlash = (url) => {
  if (!url.endsWith('/')) {
    url += '/';
  }

  return url;
};

export default buildLinkedData;
